<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal title="明细记录" :width="1200" :open="true" :confirmLoading="state.loading" :maskClosable="false"
        @ok="onFormSubmit" @cancel="cancel" :footer="null">
        <a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <a-form>
                    <a-row :gutter="48">
                        <a-col :md="8" :sm="24" v-if="!props.detailData">
                            <a-form-item label="平台名称" name="platform_id">
                                <PlatformPick v-model:value="queryParam.platform_id"></PlatformPick>
                            </a-form-item>
                        </a-col>
                        <a-col :md="8" :sm="24" v-if="!props.detailData">
                            <a-form-item label="代理商">
                                <a-input v-model:value="queryParam.nickname" placeholder="请输入"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="8" :sm="24">
                            <a-form-item label="类型" name="type">
                                <a-select mode="multiple" v-model:value="queryParam.type" placeholder="请选择">
                                    <a-select-option :value="1">充值</a-select-option>
                                    <a-select-option :value="2">支付快递费</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="8" :sm="24">
                            <a-form-item label="创建时间">
                                <BetweenTimePick v-model:value="queryParam.between_time"></BetweenTimePick>
                            </a-form-item>
                        </a-col>
                        <a-col :md="8" :sm="24">
                            <span class="table-page-search-submitButtons">
                                <a-button type="primary" @click="loadData">查询</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination"
                @change="onChange" rowKey="id">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex === 'nickname'">

                    </template>
                    <template v-else-if="column.dataIndex == 'type'">
                        <a-tag v-if="record.type == 1" color="blue">充值</a-tag>
                        <a-tag v-if="record.type == 2" color="green">消费</a-tag>
                    </template>
                    <template v-else-if="column.dataIndex === 'operate'">

                    </template>
                </template>
            </a-table>
        </a-card>
    </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed, handleError } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import PlatformPick from '@/components/base/PlatformPick.vue'
import BetweenTimePick from '@/components/base/BetweenTimePick.vue'
const emit = defineEmits(['ok', 'cancel'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const columns = [
    {
        title: '代理商',
        dataIndex: 'nickname',
    },
    {
        title: '平台',
        dataIndex: 'platform_name',

    },
    {
        title: '类型',
        dataIndex: 'type',
    },
    {
        title: '金额',
        dataIndex: 'money',
    },
    {
        title: '改变后',
        dataIndex: 'after_money',
    },
    {
        title: '时间',
        dataIndex: 'created_at',
    },
    {
        title: '备注',
        dataIndex: 'remark',
    },
    {
        title: '收款人',
        dataIndex: 'payee',
    },
    {
        title: '操作',
        dataIndex: 'operate',
        width: 200
    }
]
interface state {
    loading: boolean
    detailData: object
}
const state = reactive<state>({
    loading: false,
    detailData: {},
})
let queryParam = reactive<any>({
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '50', '100', '200', '1000', '2000'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    loadData()
})
const loadData = () => {
    state.loading = true
    queryParam.pid = props.detailData && props.detailData.id ? props.detailData.id : 0
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/platformBalance/recordList',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize }, queryParam)
    }
    baseService(requestParam).then((res) => {
        state.loading = false
        pagination.total = res.data.total_records
        dataSource.value = res.data.list.map((item) => ({ ...item, isDetail: false }))
    })
}
const onChange = (val) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}
const onFormSubmit = () => {
    emit('cancel')
}
const cancel = () => {
    emit('cancel')
}
</script>
<style lang="less" scoped></style>
